const moduleMap = {
	"./VerifyCCDetails": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_vwfs-bronson_bronson-react_dist_index_es_js-node_modules_react_jsx-runti-94829b"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_views_pages_VerifyCCDetails_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/views/pages/VerifyCCDetails.tsx */ "./src/views/pages/VerifyCCDetails.tsx")))));
	},
	"./App": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_vwfs-bronson_bronson-react_dist_index_es_js-node_modules_react_jsx-runti-94829b"), __webpack_require__.e("vendors-node_modules_stripe_react-stripe-js_dist_react-stripe_umd_js-node_modules_css-loader_-8bea3d"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_views_pages_VerifyCCDetails_tsx"), __webpack_require__.e("src_App_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/App.tsx */ "./src/App.tsx")))));
	},
	"./AppShell": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_vwfs-bronson_bronson-react_dist_index_es_js-node_modules_react_jsx-runti-94829b"), __webpack_require__.e("vendors-node_modules_stripe_react-stripe-js_dist_react-stripe_umd_js-node_modules_css-loader_-8bea3d"), __webpack_require__.e("vendors-node_modules_react-helmet_es_Helmet_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_views_pages_VerifyCCDetails_tsx"), __webpack_require__.e("src_App_tsx"), __webpack_require__.e("src_AppShell_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/AppShell.tsx */ "./src/AppShell.tsx")))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});